export class Email {
    first = "";
    last = "";
    to = "";
    message = "";
    sendTo = "";
}
